import { ApolloError } from '@parkchirp/api-client';

import { Dayjs, dayjs, getErrorMessage } from '../../../utils';

const errorCodes = ['BAD_USER_INPUT'];

export function getHistoryErrorMessage(err: ApolloError, defaultMessage: string) {
	return getErrorMessage(err, errorCodes) ?? defaultMessage;
}

export const getMinDate = (billingStartDate: Dayjs, editingStartDateRecord: boolean) => {
	const dayAfterBillingStartDate = billingStartDate.add(1, 'day');
	return editingStartDateRecord ? billingStartDate : dayAfterBillingStartDate;
};

export const shouldDisableDate = (history: { id: number; startDate: string }[], historyId: number, date: Dayjs) =>
	history.some((h) => dayjs.utc(h.startDate).isSame(date, 'day') && h.id !== historyId);
